import React, { Component } from 'react';
import { FormGroup, FormControl, Table } from 'react-bootstrap';
import moment from 'moment';
import LoaderButton from '../components/LoaderButton';
import { invokeApig } from '../libs/awsLib';
import ConfirmationModal from '../components/ConfirmationModal/ConfirmationModal';

export default class UploadForecast extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      isLoading: false,
      uploadURL: '',
      file: '',
      fileContents: '',
      uploadAlerts: [],
      showConfirmModal: true,
    };
    this.uploadForecast = this.uploadForecast.bind(this);
    this.setShowConfirmModal = this.setShowConfirmModal.bind(this);
  }

  async componentDidMount() {
    this.getUploadURL();
  }

  async getUploadURL() {
    try {
      const test = await invokeApig({
        path: '/forecast/upload/url',
        method: 'GET',
      });

      this.setState({
        uploadURL: test.body.url.replace('.s3.', '.s3-us-west-2.'),
      });
    } catch (e) {
      console.error(e);
    }
  }

  async uploadForecast(event) {
    if (this.state.uploadURL === '') {
      return;
    }
    this.setState({
      isLoading: true,
    });

    const theFormFile = this.state.file;
    const request = new XMLHttpRequest();
    request.open('PUT', this.state.uploadURL, true);
    request.setRequestHeader('Content-Type', 'text/csv');
    request.onerror = function () {
      console.log(request.responseText);
    };
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        // Normal
      } else {
        // We reached our target server, but it returned an error
      }
      this.setState({
        file: '',
        fileContents: '',
        uploadURL: '',
        isLoading: false,
      });
      this.getUploadURL();
    }.bind(this);
    request.send(theFormFile);
  }

  validateLine = (line) => {
    const errors = [];
    const allocationDate = moment(line.AllocationDate, 'YYYY/MM/DD', true);
    const productionDate = moment(line.ProductionDate, 'YYYY/MM/DD', true);
    const diffDays = allocationDate.diff(productionDate, 'days');
    const item = line.Item;

    // Validate `ProductionDate` column
    if (
      line.ProductionDate &&
      !moment(line.ProductionDate, 'YYYY/MM/DD', true).isValid()
    ) {
      errors.push('`ProductionDate` should be in `YYYY/MM/DD` format');
    }

    // Validate `AllocationDate` column
    if (
      line.AllocationDate &&
      !moment(line.AllocationDate, 'YYYY/MM/DD', true).isValid()
    ) {
      errors.push('`AllocationDate` should be in `YYYY/MM/DD` format');
    }

    // Validate `AllocationDate` - `ProductionDate` > 1
    console.log(diffDays);
    if (diffDays > 1) {
      this.state.uploadAlerts.push(
        `Holdover of ${diffDays} days for ${item} and Production Date ${line.ProductionDate}`,
      );
    }

    return errors;
  };

  handleFileChange = (event) => {
    this.setState({
      fileContents: '',
    });

    const file = event.target.files[0];
    if (file && file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
      alert('Please upload a .csv file');
      return;
    }

    window.Papa.parse(event.target.files[0], {
      header: true,
      dynamicTyping: true,
      complete: function (fileData) {
        const linesValidationErrors = [];
        fileData.data.forEach((line, i) => {
          const lineValidationErrors = this.validateLine(line);
          console.log('line ', i + 2, ' - ', lineValidationErrors);
          if (lineValidationErrors.length) {
            linesValidationErrors.push(
              `\n[Line ${i + 2}] ${lineValidationErrors.join('\n')}`,
            );
          }
        });

        if (linesValidationErrors.length) {
          alert(linesValidationErrors);
        } else {
          this.setState({
            fileContents: fileData,
          });
        }
      }.bind(this),
    });
    this.setState({
      file: event.target.files[0],
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
  };

  validateForm() {
    return this.state.uploadURL !== '' && this.state.file !== '';
  }

  setShowConfirmModal(show) {
    this.setState({ showConfirmModal: show });
  }

  render() {
    let headers;
    let rows;
    if (this.state.fileContents !== '') {
      headers = Object.keys(this.state.fileContents.data[0]).map((header) => (
        <th key={header}>{header}</th>
      ));
      rows = this.state.fileContents.data.map((header) => (
        <tr key={header.Item + header.AllocationDate}>
          <td>{header.Item}</td>
          <td>{header.AllocationDate}</td>
          <td>{header.Quantity}</td>
          <td>{header.ProductionDate}</td>
        </tr>
      ));
    }

    return (
      <div className="Locations">
        <FormGroup controlId="file">
          <FormControl
            onClick={(event) => {
              event.target.value = null;
            }}
            onChange={this.handleFileChange}
            type="file"
          />
        </FormGroup>
        {this.state.uploadAlerts?.length > 0 && (
          <ConfirmationModal
            title="Holdover Alert"
            show={this.state.showConfirmModal}
            onHide={() => this.setShowConfirmModal(false)}
            onConfirm={() => this.setShowConfirmModal(false)}
          >
            <ul>
              {this.state.uploadAlerts.map((alert, index) => (
                <li key={index}>{alert}</li>
              ))}
            </ul>
          </ConfirmationModal>
        )}
        {this.state.fileContents !== '' && (
          <Table bordered responsive>
            <thead>
              <tr>{headers}</tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>
        )}

        <LoaderButton
          block
          bsStyle="primary"
          bsSize="large"
          disabled={!this.validateForm()}
          onClick={this.uploadForecast}
          type="submit"
          isLoading={this.state.isLoading}
          text="Upload Forecast"
          loadingText="Uploading Forecast…"
        />
      </div>
    );
  }
}
